module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-lightitalic-webfont.4792fdcf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-lightitalic-webfont.ttf
// module id = 367
// module chunks = 3